module.exports = __webpack_public_path__ + "static/media/cyprus.93a9565e.png";